import { render, staticRenderFns } from "./ComponentTradeOnCredit.vue?vue&type=template&id=6fbc15ac"
import script from "./ComponentTradeOnCredit.vue?vue&type=script&lang=js"
export * from "./ComponentTradeOnCredit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports